const topics = [
  { tag: '#星际穿越2', heat: '986万' },
  { tag: '#暑期档推荐', heat: '872万' },
  { tag: '#国产悬疑', heat: '765万' },
  { tag: '#韩剧推荐', heat: '691万' },
  { tag: '#高分经典', heat: '634万' },
  { tag: '#动画电影', heat: '558万' },
  { tag: '#日剧同步', heat: '489万' },
  { tag: '#动作大片', heat: '432万' },
  { tag: '#美剧热播', heat: '398万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题标签
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            当前最受关注的热议影视话题与内容标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topics.map((topic, i) => {
            const sizes = ['md', 'lg', 'sm', 'md', 'lg', 'sm', 'md', 'sm', 'md'];
            const sizeClass = sizes[i] === 'lg' ? 'px-5 py-3 text-base' : sizes[i] === 'md' ? 'px-4 py-2.5 text-sm' : 'px-3 py-2 text-xs';
            return (
              <a
                key={i}
                href="#cards"
                className={`whitespace-nowrap group inline-flex items-center gap-2 ${sizeClass} font-medium text-foreground-700 hover:text-accent-600 bg-background-100 hover:bg-background-200 border border-background-200/60 hover:border-accent-300/50 rounded-full transition-all duration-200 no-underline`}
              >
                <span>{topic.tag}</span>
                <span className="text-xs text-foreground-400 group-hover:text-accent-400">{topic.heat}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}